var ReduxAction = /** @class */ (function () {
    function ReduxAction(type, payload) {
        this.type = type;
        this.payload = payload;
    }
    return ReduxAction;
}());
export { ReduxAction };
//# sourceMappingURL=redux-action.js.map